import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import styles from './DeleteHospitalRecordDialog.module.css';

const DeleteHospitalRecordDialog = () => {
  const { popupStore, hospitalFilesStore } = useStore();
  const record = hospitalFilesStore.recordToDelete;

  const handleClose = () => {
    popupStore.setIsDeleteConfirmationOpen(false);
    hospitalFilesStore.setRecordToDelete(null);
  };

  const handleConfirm = async () => {
    if (!record?.id) {
      return;
    }

    await hospitalFilesStore.deleteRecord(record.id);
    handleClose();
  };

  const message = record ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki cihaz kaydını silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Cihaz Tanımı</span>
          <span className={styles.detailValue}>
            {record.biomedicalDeviceDescription || '—'}
          </span>
        </li>
        {record.tagNumberWithColor ? (
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Etiket No</span>
            <span className={styles.detailValue}>{record.tagNumberWithColor}</span>
          </li>
        ) : null}
        {record.identificationNumber ? (
          <li className={styles.detailItem}>
            <span className={styles.detailLabel}>Künye No</span>
            <span className={styles.detailValue}>{record.identificationNumber}</span>
          </li>
        ) : null}
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeleteConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Kayıt Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeleteHospitalRecordDialog);
